import type { GooglePlace, ImportedPlace } from "../../utils/services/GoogleMapsPlaces";

/**
 * What opening a Google Maps result in the Explore search does, once it has
 * been added to our places (`ours`) — or couldn't be (`null`):
 *  - on a page with a map that can show places, fly there and open its sheet;
 *  - on any other page with a map, at least fly there;
 *  - with no map, go to its page, or failing that to the map at it.
 */
export type GooglePlaceAction =
  | { kind: 'sheet'; coordinates: [number, number]; place: ImportedPlace }
  | { kind: 'fly'; coordinates: [number, number] }
  | { kind: 'navigate'; url: string };

export function googlePlaceAction(
  place: GooglePlace,
  ours: ImportedPlace | null,
  page: { hasMap: boolean; canShowPlaces: boolean }
): GooglePlaceAction {
  const coordinates = ours?.coordinates ?? place.coordinates;
  if (ours && page.hasMap && page.canShowPlaces) return { kind: 'sheet', coordinates, place: ours };
  if (page.hasMap) return { kind: 'fly', coordinates };
  if (ours?.shareUrl) return { kind: 'navigate', url: ours.shareUrl };
  return { kind: 'navigate', url: `/map?lat=${coordinates[1]}&lng=${coordinates[0]}` };
}
